var exports = {
  "g": "Main__oDEqdO",
};

module.exports = exports;
